import classnames from 'classnames';
import Button from '../button';
import React from 'react';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import '../../../stylesheets/native-alert-styles.scss';

interface NativeAlertDeleteButtonProps {
  setShowAlert: (showAlert: boolean) => void;
  formName: string;
}

export const NativeAlertDeleteButton = ({
  setShowAlert,
  formName,
}: NativeAlertDeleteButtonProps): React.ReactElement => {
  const mq = useMediaQuery();
  return (
    <div
      className={classnames('prefix-flex', 'prefix-flex-grow-2', {
        'portfolio-form-footer-delete-button': mq.MS_AND_DOWN,
      })}
    >
      <Button
        onClick={() => setShowAlert(true)}
        color="negative"
        outline
        width={mq.MS_AND_DOWN ? '100%' : '80px'}
        margin={false}
        buttonName={`${formName} form-footer delete-button`}
      >
        Delete
      </Button>
    </div>
  );
};
